import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import { Link } from "react-router-dom";
import axios from "../../api/axios";

Project.propTypes = {
  data: PropTypes.array,
};

function Project(props) {
  const { data } = props;
  const [users, setUsers] = useState([]);

  const [dataBlock] = useState({
    subheading: "We Rewards",
    heading: "OUR USERS",
  });

  useEffect(() => {
    const getUsersHome = async () => {
      await axios.get("/users/publicUsers").then((res) => {
        console.log(res.data);
        setUsers(res.data.users);
      });
    };
    getUsersHome();
  }, []);

  return (
    <section className="project">
      <div className="shape right"></div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="block-text center">
              <h6 className="sub-heading">
                <span>{dataBlock.subheading}</span>
              </h6>
              <h3 className="heading">{dataBlock.heading}</h3>
            </div>

            <Swiper
              className="project-swiper"
              spaceBetween={30}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                991: {
                  slidesPerView: 3,
                },
              }}
              loop={true}
              modules={[Navigation, Pagination]}
              navigation
              pagination={{
                clickable: true,
              }}
            >
              {users.length > 0 ? (
                users.map((idx) => (
                  <SwiperSlide key={idx._id}>
                    <div className="swiper-slide">
                      <div className="project-box">
                        <div className="image">
                          <Link to="/">
                            <img src={idx.profilePicture} alt="Cyfonii" />
                          </Link>
                        </div>
                        <div className="content">
                          <Link to="/" className="h5 title">
                            {idx.pubgName}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))
              ) : (
                <></>
              )}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Project;
